import axios from '../../../adapters/axios'

export const login = async(user : {email : string, password : string}) =>  {
  return await axios.post('login', user)
}